<div class="flex flex-col gap-3 min-w-72 md:min-w-85 shrink-0 border-2 border-secondary p-3 md:p-5">
  <!-- Column Header -->
  <div [class]="color() + ' border-2 border-secondary rounded-sm px-2 md:px-3 py-3 md:py-4'">
    <div class="flex items-center justify-between">
      <h3 class="text-sm md:text-base text-text-white">{{ title() }}</h3>
      <button
        class="bg-sky-mint border-2 border-secondary rounded-sm flex items-center px-2 md:px-3 shadow-[3px_3px_0_0_var(--color-secondary)] cursor-pointer hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[2px_2px_0_0_var(--color-secondary)]"
        (click)="menuClicked.emit(columnId())"
      >
        <ng-icon name="heroXMark" size="1.25rem" class="md:text-2xl"></ng-icon>
      </button>
    </div>
  </div>

  <!-- Cards List -->
  <div class="flex flex-col gap-3 md:gap-4">
    <div
      class="flex flex-col gap-3 md:gap-4 pr-1 min-h-24"
      cdkDropList
      [id]="columnId()"
      [cdkDropListData]="localCards()"
      (cdkDropListDropped)="onDrop($event)"
    >
      @for (card of localCards(); track card.id) {
        <div cdkDrag>
          <app-kanban-card
            [cardId]="card.id"
            [title]="card.title"
            [labels]="card.labels"
            [assignee]="card.assignee"
            [commentsCount]="card.commentsCount"
            [attachmentsCount]="card.attachmentsCount"
            (clicked)="cardClicked.emit(card.id)"
            (delete)="handleDeleteCard(card.id)"
          />
        </div>
      }
    </div>

    <!-- Add Card Button -->
    @if (isAddingCard()) {
      <div>
        <textarea
          rows="5"
          placeholder="Card title"
          class="w-full resize-none p-2 md:p-3 border-2 border-secondary rounded-sm mb-2 mt-3 text-sm md:text-base"
          [(ngModel)]="newCardTitle"
          (keydown.enter)="$event.preventDefault(); handleAddCard()"
          (keydown.escape)="cancelAddCard()"
        ></textarea>
        <div class="flex items-center gap-2 md:gap-3">
          <button
            class="w-full bg-accent border-2 border-secondary rounded-sm shadow-[3px_3px_0_0_var(--color-secondary)] py-2 text-base md:text-lg hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[2px_2px_0_0_var(--color-secondary)] transition-all cursor-pointer"
            (click)="handleAddCard()"
          >
            Add Card
          </button>
          <div
            class="rounded-full w-10 h-10 md:w-11 md:h-10 bg-scarlet-rush flex items-center justify-center cursor-pointer shrink-0"
            (click)="cancelAddCard()"
          >
            <ng-icon name="heroXMark" size="1.25rem" class="md:text-2xl" color="white"></ng-icon>
          </div>
        </div>
      </div>
    } @else {
      <button
        class="w-full bg-accent border-2 border-secondary rounded-sm shadow-[3px_3px_0_0_var(--color-secondary)] py-2 text-base md:text-lg hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[2px_2px_0_0_var(--color-secondary)] transition-all cursor-pointer"
        (click)="isAddingCard.set(true)"
      >
        Add Card
      </button>
    }
  </div>
</div>
